// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label {
    width: 100%;

    span {
        width: 100%
    }

}

.card {
    justify-content: space-between;
    align-items: flex-start;
    display: flex;
    border: none;
}

.card-container {
    flex-direction: column;
    align-items: flex-end;
    display: flex;
    width: 100%;
}

.container, .multiple-item {
    align-items: center;
    margin-top: 2px;
    display: flex;
    width: 100%;
}

.multiple-item {
    justify-content: right;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal
}

.avatar {
    background-color: transparent;
    margin-bottom: 0.5px;
    width: 25px;
    height: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Upload/GenericFileUpload.css"],"names":[],"mappings":"AAAA;IACI,WAAW;;IAEX;QACI;IACJ;;AAEJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB","sourcesContent":[".label {\n    width: 100%;\n\n    span {\n        width: 100%\n    }\n\n}\n\n.card {\n    justify-content: space-between;\n    align-items: flex-start;\n    display: flex;\n    border: none;\n}\n\n.card-container {\n    flex-direction: column;\n    align-items: flex-end;\n    display: flex;\n    width: 100%;\n}\n\n.container, .multiple-item {\n    align-items: center;\n    margin-top: 2px;\n    display: flex;\n    width: 100%;\n}\n\n.multiple-item {\n    justify-content: right;\n    overflow-wrap: break-word;\n    word-break: break-word;\n    white-space: normal\n}\n\n.avatar {\n    background-color: transparent;\n    margin-bottom: 0.5px;\n    width: 25px;\n    height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
